import { render, staticRenderFns } from "./CasesContainer.vue?vue&type=template&id=46c53b87&scoped=true"
import script from "./CasesContainer.vue?vue&type=script&lang=js"
export * from "./CasesContainer.vue?vue&type=script&lang=js"
import style0 from "./CasesContainer.vue?vue&type=style&index=0&id=46c53b87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c53b87",
  null
  
)

export default component.exports